import { connect } from 'react-redux';
import { switchPeriod } from '../../../api/periods/shared/periodsActions';
import { generatePdf } from '../../../api/pdfGeneration/shared/pdfActions';
import HomeConnect from '../../../features/homeConnect/HomeConnect';
import { selectors } from '../../../root/reading/root';
import { BASE_URLS } from '../../../constants/reading/ApiConstants';
import LinkWrapper from '../../../features/navigation/LinkWrapper';
import { PERIOD } from '../../../constants/shared/CommonConstants';
import { getUrlParams } from '../../../utils/shared/urlUtils';
import { toyTabs } from '../../../utils/shared/navigationUtils';

const mapStateToProps = state => {
    const location = selectors.getLocation(state);
    const params = getUrlParams(location);
    const isSummerPeriodPresent = selectors.getToyPeriods(state).includes(PERIOD.SUMMER);
    return {
        studentsData: selectors.getHomeConnectStudentsData(state),
        classOrGroupInfo: selectors.getClassOrGroupInfo(state),
        period: selectors.getSelectedPeriodWithoutSummary(state),
        currentPeriod: selectors.getCurrentPeriod(state),
        isPdfDownloading: selectors.isPdfDownloading(state),
        isDemoModeOn: selectors.getIsDemoModeOn(state),
        isGuidedTourOn: selectors.getIsGuidedTourOn(state),
        LinkWrapper,
        toyTabs: toyTabs(
            location,
            BASE_URLS.HOME_CONNECT_URL,
            {
                burstGroupUid: params.burstGroupUid,
            },
            isSummerPeriodPresent,
            selectors.getSummerPeriodLabel(state),
        ),
    };
};

const mapDispatchToProps = dispatch => ({
    generateHCPDF: pdfConfiguration => {
        dispatch(generatePdf(pdfConfiguration));
    },
    switchPeriod: period => {
        dispatch(switchPeriod(period));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeConnect);
